<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="编辑手册"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 style="width: 22%;min-width:325px;margin-left: 10%;float: left;" autocomplete="off">

            <el-form-item label="手册文件" :label-width="formLabelWidth" prop="file">
                <el-upload ref="upload" class="upload-demo" accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG"
                           :action="upload_agreement_path" :file-list="fileList"
                           :on-success="handleSuccess" :before-upload="beforeAvatarUpload" list-type="picture"
                           :multiple="true">
                    <div slot="file" slot-scope="{file}">
                        <div>
                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt=""/>
                            <!--                            <a class="el-upload-list__item-name"><i class="el-icon-document"></i>{{ file.name }}</a>-->
                            <label class="el-upload-list__item-status-label">
                                <i class="el-icon-upload-success el-icon-check"></i>
                            </label>
                            <i class="el-icon-close" @click="handleRemove(file)"></i>
<!--                            <i class="el-icon-close-tip">按 delete 键可删除</i>-->
                        </div>
                        <!--                        <div class="form-box">-->
                        <!--                            <el-form-item label="姓名：" prop="nick_name">-->
                        <!--                                <el-input type="text" v-model="ruleForm.expert_name" placeholder="请输入专家姓名"-->
                        <!--                                          autocomplete="off"-->
                        <!--                                          style="width: 90%; margin-left: 0;"></el-input>-->
                        <!--                            </el-form-item>-->
                        <!--                            <el-form-item label="单位：" prop="nick_name">-->
                        <!--                                <el-input type="text" v-model="ruleForm.expert_hospital" placeholder="请输入专家所属单位"-->
                        <!--                                          autocomplete="off"-->
                        <!--                                          style="width: 90%; margin-left: 0;"></el-input>-->
                        <!--                            </el-form-item>-->
                        <!--                            <el-form-item label="科室：" prop="nick_name">-->
                        <!--                                <el-input type="text" v-model="ruleForm.expert_department" placeholder="请输入专家科室"-->
                        <!--                                          autocomplete="off"-->
                        <!--                                          style="width: 90%; margin-left: 0;"></el-input>-->
                        <!--                            </el-form-item>-->
                        <!--                        </div>-->
                    </div>

                    <el-button class="upload_btn" size="small" type="primary">点击上传
                    </el-button>
                    <div slot="tip" class="el-upload__tip">注：请上传小于5M的PNG/JGP图片</div>

                </el-upload>

                <div class="upload-demo">
                    <el-button class="file_view" size="small" type="primary"
                               @click="oneReservationDetail({contract_file: JSON.stringify(addFileList)})">预览手册
                    </el-button>
                </div>

            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
        <div style="height: 70px;"></div>
        <el-form class="expert-info" v-for="(itemlist, index) in addFileList" :key="index"
                 style="width: 40%;float: left;margin-left: 5%;height: 160px;margin-top: 30px;transform: translateY(17px)">
            <el-form-item style="transform: translateY(-10px)">
                <div class="form-box">
                    <el-form-item label="姓名：" prop="nick_name">
                        <el-autocomplete class="user_search"
                                         v-model="ruleForm.expert_info[index].expert_name"
                                         :fetch-suggestions="searchExpert"
                                         :label="itemlist.index_flg"
                                         placeholder="请输入内容"
                                         @select="selectExpert($event, index)"
                                         @blur="resetExpertInfo($event, index)"
                                         @focus="savetExpertInfo($event, index)"
                        ></el-autocomplete>

                    </el-form-item>
                    <el-form-item label="单位：" prop="nick_name">
                        <el-input type="text" :disabled="true" v-model="ruleForm.expert_info[index].expert_hospital"
                                  placeholder="请输入专家所属单位"
                                  autocomplete="off"
                                  style="width: 90%;max-width: calc(100% - 4em); margin-left: 0;"></el-input>
                    </el-form-item>
                    <el-form-item label="科室：" prop="nick_name">
                        <el-input type="text" :disabled="true" v-model="ruleForm.expert_info[index].expert_department"
                                  placeholder="请输入专家科室"
                                  autocomplete="off"
                                  style="width: 90%;max-width: calc(100% - 4em); margin-left: 0;"></el-input>
                    </el-form-item>
                </div>
            </el-form-item>
        </el-form>
        <el-dialog title="手册预览" :visible.sync="dialogContractFormVisible">
            <el-carousel indicator-position="outside" height="500px" :autoplay="false">
                <el-carousel-item v-for="url in allContractUrls" :key="url">
                    <div class="image_box">
                        <el-image :src="url"></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {fileType} from "@/api/order";

export default {
    mounted() {
        this.getAllExpert()
        this.getExpertManual()
    },
    data() {
        return {
            restaurants: [],
            allExpert: [], // 所有专家
            is_start: true,
            expertSearchRes: [], // 专家搜索结果
            prev_search: '',
            dialogContractFormVisible: false,
            fileList: [],
            addFileList: [],
            allContractUrls: [],
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            upload_agreement_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=99',
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            ruleForm: {
                file: "",
                protocol_name: "",
                sort: "",
                status: 1,
                content: "",
                expert_info: [
                    // {
                    //     expert_name: '',
                    //     expert_hospital: '',
                    //     expert_department: '',
                    //     expert_user_id: '',
                    // }
                ],
            },
            rules: {
                // protocol_name: [
                //     {required: true, message: "请输入协议名称", trigger: "blur"},
                // ],
                // role: [
                //     {required: true, message: "请选择前端", trigger: "blur"},
                // ],
                // content: [
                //     {required: true, message: "请填写协议内容", trigger: "blur"},
                // ],
                // file: [{
                //     required: true,
                //     message: "请上传协议",
                //     trigger: "blur"
                // },],
            },
            formLabelWidth: '120px',
        };
    },
    methods: {
        getFileType(url) {
            return fileType(url)
        },
        // 返回上一页
        goBack() {
            window.history.go(-1);
        },

        // 提交表单
        submitForm(formName) {
            this.$refs[formName].validate(valid => {

                if (valid) {
                    let params = {
                        'servername': 'Ruyi_AdminDoctorServices',
                        'method': 'createManual',
                        'params': {
                            expert_manuals: this.addFileList,
                            expert_info: this.ruleForm.expert_info,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '编辑成功',
                            duration: 1500,
                            onClose: function () {
                                window.history.go(-1);
                            }
                        });
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    return false;
                }
            });
        },
        getExpertManual() {

            let params = {
                servername: "Ruyi_AdminDoctorServices",
                method: "getManual",
                pageinfo: {
                    perpage: -1,
                    page: 1,
                },
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data) {

                    for (let i = 0; i < res.data.data.length; i++) {
                        this.fileList.push({
                            response: {
                                data: {
                                    file: res.data.data[i].manaul
                                }
                            },
                            url: this.imgUrl + res.data.data[i].manaul,
                        });
                        this.addFileList.push({
                            file: res.data.data[i].manaul
                        })
                        this.ruleForm.expert_info.push({
                            expert_name: res.data.data[i].user_name,
                            expert_hospital: res.data.data[i].hospital,
                            expert_department: res.data.data[i].hospital_department,
                            expert_user_id: res.data.data[i].user_id,
                            id: res.data.data[i].id,
                        })
                    }
                }

            });
        },
        getAllExpert() {

            let params = {
                servername: "Ruyi_AdminDoctorServices",
                method: "listing",
                pageinfo: {
                    perpage: -1,
                    page: 1,
                },
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data.list) {

                    for (let i = 0; i < res.data.data.list.length; i++) {
                        res.data.data.list[i].value = res.data.data.list[i].user_name
                    }
                }
                this.expertSearchRes = this.allExpert = res.data.data.list;
                this.is_start = false;
            });
        },
        searchExpert(key, cb) {
            if (key != undefined && key.indexOf('/') > -1) {
                this.prev_search = key.split('/')[1] || key.split('/')[0]
                key = this.prev_search
            }
            if (!key && this.is_start) {
                this.search_key = '';
                cb(this.expertSearchRes);
                return;
            }
            this.search_key = key

            let params = {
                servername: "Ruyi_AdminDoctorServices",
                method: "listing",
                params: {
                    user_name: key
                },
                pageinfo: {
                    perpage: -1,
                    page: 1,
                },
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data.list) {
                    for (let i = 0; i < res.data.data.list.length; i++) {
                        res.data.data.list[i].value = res.data.data.list[i].user_name
                    }
                }
                this.expertSearchRes = res.data.data.list;
                // this.expertSearchRes 中移除已选择的专家
                for (let i = 0; i < this.ruleForm.expert_info.length; i++) {
                    for (let j = 0; j < this.expertSearchRes.length; j++) {
                        if (this.expertSearchRes[j].user_id == this.ruleForm.expert_info[i].expert_user_id) {
                            this.expertSearchRes.splice(j, 1);
                            break;
                        }
                    }
                }
                cb(this.expertSearchRes);

                this.is_start = false;
            });
        },
        selectExpert(item, index) {
            for (let i = 0; i < this.ruleForm.expert_info.length; i++) {
                if (this.ruleForm.expert_info[i].expert_user_id == item.user_id) {
                    this.$message({
                        type: "error",
                        message: '专家'+ item.user_name + '已有档案手册，请选择其他专家'
                    });
                    this.ruleForm.expert_info[index].expert_name = '';
                    this.ruleForm.expert_info[index].expert_user_id = '';
                    this.ruleForm.expert_info[index].expert_hospital = '';
                    this.ruleForm.expert_info[index].expert_department = '';
                    return;
                }
            }
            this.ruleForm.expert_info[index].expert_user_id = item.user_id
            this.ruleForm.expert_info[index].expert_hospital = item.hospital
            this.ruleForm.expert_info[index].expert_department = item.hospital_department

        },
        // 失去焦点
        resetExpertInfo(event, index) {
            if (this.ruleForm.expert_info[index].expert_user_id) {
               this.ruleForm.expert_info[index].expert_name =  this.prev_search
            }
        },
        // 获取焦点
        savetExpertInfo(event, index) {
            if (this.ruleForm.expert_info[index].expert_name) {
                this.prev_search = this.ruleForm.expert_info[index].expert_name
            }
            this.expertSearchRes = this.allExpert
            // this.expertSearchRes 中移除已选择的专家
            for (let i = 0; i < this.ruleForm.expert_info.length; i++) {
                for (let j = 0; j < this.expertSearchRes.length; j++) {
                    if (this.expertSearchRes[j].user_id == this.ruleForm.expert_info[i].expert_user_id) {
                        this.expertSearchRes.splice(j, 1);
                        break;
                    }
                }
            }
        },
        // 除去图片
        handleRemove(file) {
            let index = '';
            let _that = this;
            let id = '';
            for (let i = 0; i < this.addFileList.length; i++) {
                if (file.response.data.file == this.addFileList[i].file) {
                    index = i
                    id = this.ruleForm.expert_info[i].id
                    // this.ruleForm.expert_info.splice(i, 1);
                    // this.addFileList.splice(i, 1);
                }
            }
            if (!id) {
                // 删除新添加还没保存到服务器的
                _that.$refs.upload.handleRemove(file)
                _that.ruleForm.expert_info.splice(index, 1);
                _that.addFileList.splice(index, 1);
                return;
            }
            this.$confirm('确定要删除该画册吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                let params = {
                    servername: 'Ruyi_AdminDoctorServices',
                    method: 'delManual',
                    params: {
                        id: id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '删除成功',
                        duration: 1500,
                    });
                });
                _that.$refs.upload.handleRemove(file)
                _that.ruleForm.expert_info.splice(index, 1);
                _that.addFileList.splice(index, 1);
                // for (let i = 0; i < this.addFileList.length; i++) {
                //     if (file.response.data.file == this.addFileList[i].file) {
                //         this.ruleForm.expert_info.splice(i, 1);
                //         this.addFileList.splice(i, 1);
                //     }
                // }
            }).catch(() => {
            });


        },

        // 上传图片成功
        handleSuccess(response, file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        fileList[i].response.data.index_flg = i.toString();
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        let obj = {
                            file: name,
                            x: fileList[i].x,
                            y: fileList[i].y,
                            index_flg: i.toString(),
                        };
                        addFileList.push(obj);
                    }
                }
            }

            if (addFileList.length > this.ruleForm.expert_info.length) {
                for (let i = 0; i < (addFileList.length - this.ruleForm.expert_info.length); i++) {
                    this.ruleForm.expert_info.push({
                        expert_name: '',
                        expert_hospital: '',
                        expert_department: '',
                        expert_user_id: '',
                    })
                }
            }

            this.addFileList = addFileList;
            this.ruleForm.file = "file";


        },
        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('图片只能是jpg/png/pdf格式!');
            }
            if (!isLt5M) {
                isJPG = false;
                this.$message.error('图片大小不能超过5MB!');

            }
            return isJPG;
        },
        // 协议详情-预览
        oneReservationDetail(data) {
            this.allContractUrls = [];
            var allContractUrls = [];
            if (data.contract_file) {
                var contract_file = JSON.parse(data.contract_file);
                if (contract_file.length > 0) {
                    for (var i = 0; i < contract_file.length; i++) {
                        var url = this.imgUrl + contract_file[i].file;
                        allContractUrls.push(url);
                    }
                }
            }
            this.allContractUrls = allContractUrls;
            this.dialogContractFormVisible = true;
        },
    }

};
</script>
<style lang="scss">

.yy {
    z-index: 15000 !important;
}

.image_box {
    height: 500px;
    overflow: hidden;
    overflow-y: auto;

    image {
        width: 100%;
    }
}

.upload_btn {
    position: absolute;
    top: 0;
    left: 30px;
}

.file_view {
    position: absolute;
    top: 0;
    left: 130px;
}


.form-box {
    .el-form-item {
        height: 40px;
        margin-top: 10px;
    }

    .el-form-item__label {
        text-align: left !important;
        width: 4em !important;
    }

    .el-form-item__content {
        margin-left: 2em !important;
    }
}

.el-upload-list--picture .el-upload-list__item {
    height: 180px;
    padding-left: 10px;
    width: 100%;
}

.el-upload-list--picture .el-upload-list__item-thumbnail {
    width: 160px;
    height: 160px;
    margin: 0 auto;
    float: none;
    max-width: 100%;
    max-height: 100%;
}

.el-form-item .is-required {
    width: 100%;
}

.el-form-item__content {
    width: calc(100% - 120px);
}

.upload-demo {
    width: 100%;
}

.el-upload-list .el-upload-list--picture {
    width: 100%;
}

.user_search {
    text-align: left;
    width: 90%;
    max-width: calc(100% - 4em);
}

</style>
